import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { ChatActionItem } from '@/modules/Chat/interfaces/ChatActionItem';
import ChatKebabOptions from '@/modules/Chat/components/ChatKebabOptions.vue';
import { generateMessageHeaderString } from '@/modules/Chat/helpers/ChatHelper';
import { UserRepository } from '@/repositories/UserRepository';
import { ChatRenderedMessage } from '@/modules/Chat/interfaces/ChatRenderedMessage';

interface Props {
    chatActionList: ChatActionItem[];
    message: ChatRenderedMessage;
    type: string;
    isMadeByUserSameAsCurrentUser: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessageHeader',
  props: {
    chatActionList: null,
    message: null,
    type: null,
    isMadeByUserSameAsCurrentUser: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
    chatActionList: ChatActionItem[];
    message: ChatRenderedMessage;
    type: string;
    isMadeByUserSameAsCurrentUser: boolean;
};



const currentUser = computed(() => UserRepository.getCurrentUser());

const messageHeaderInfo = computed(() => {
    if (currentUser.value == null) {
        return '';
    }

    return generateMessageHeaderString(props.message, currentUser.value, props.type);
});

return { __sfc: true,props, currentUser, messageHeaderInfo, ChatKebabOptions }
}

})